// import { useVocStore } from '@/pinia/general/voc';
// import { useEnvStore } from '@/pinia/general/env';

export default async function environment({ context, nextMiddleware }) {
  try {
    // const useVoc = useVocStore(context.pinia);
    // const envStore = useEnvStore(context.pinia);
    // await envStore.getEnv();
    // await useVoc.getVoc();

    await context.store.dispatch('getEnv');

    await Promise.all([context.store.dispatch('getI18n'), context.store.dispatch('getColor')]);
  } catch (e) {
    console.error(e);
    context.next(false);
  }

  context.store.dispatch('setTheme');

  return nextMiddleware();
}
